import React, { Fragment } from 'react'
import { Grid } from '@material-ui/core'
import InputGroup from '../../../../../../UI/Forms/InputGroup/InputGroup'

const PrimaryForm = ({ form, formInputChanged }) => {
  const inputDisplay = Object.entries(form).map(formControl => {
    let [formKey, formAttrs] = formControl
    return (
      <Grid key={formKey} item xs={12} sm={6} md={6} lg={3}>
        <InputGroup
          label={formAttrs.label}
          inputType={formAttrs.elementType}
          configs={formAttrs.elementConfig}
          invalid={!formAttrs.valid}
          validations={formAttrs.validation}
          touched={formAttrs.touched}
          changed={e => formInputChanged(formKey, e)}
          inputValue={formAttrs.value}
          validationError={formAttrs.error}
        />
      </Grid>
    )
  })

  return <Fragment>{inputDisplay}</Fragment>
}

export default PrimaryForm
